// extracted by mini-css-extract-plugin
export default {"form":"payment-details__form___ryhD6","stripeIconWrapper":"payment-details__stripeIconWrapper___J0zjJ","payButton":"payment-details__payButton___j9TT5"};